import "./App.css";
import About from "./Components/About";
import ContactForm from "./Components/ContactForm";
import Footer from "./Components/Footer";
// import ChatWidget from "./Components/ChatWidget";
import HomePage from "./Components/HomePage";
import Blog from "./Components/Blog";
import BlogDetail from "./Components/BlogDetail";
import ProcuralWellBeing from "./Components/ProcuralWellBeing";
import EmpFeedbackForm from "./Components/EmpFeedbackForm";

import {
  HashRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Header from "./Components/Header";
import { gtmPush } from "./utils/gtm";
import { useEffect } from "react";
import { useHeadMeta } from "./hooks/useHeadMeta";
import { pageConfig } from "./utils/seoUtils";

function AppRoutes() {
  const location = useLocation();

  const pathMetaMap = {
    "/": pageConfig.home,
    "/about": pageConfig.about,
    "/blog": {
      ...pageConfig.home,
      title: "Blog | Srilatha Rakesh",
      description:
        "Read practical, uplifting blog posts on anxiety, resilience, burnout, relationships, and personal growth from Srilatha Rakesh.",
      url: "https://www.srilatharakesh.com/#/blog",
      type: "website",
    },
    "/contact": pageConfig.contact,
    "/procural-well-being": pageConfig.procuralWellbeing,
    "/employee-feedbackform": pageConfig.employeeFeedback,
  };

  const routeMeta = pathMetaMap[location.pathname] || pageConfig.home;

  useHeadMeta(routeMeta);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location.pathname, location.hash]);

  useEffect(() => {
    gtmPush("page_view", {
      page_location: window.location.href,
      page_path: location.pathname + location.hash,
      page_title: document.title,
      route_name: location.pathname || "/",
      event_category: "page_view",
      event_label: location.pathname || "/",
    });
  }, [location]);

  return (
    <>
      <Header />
      <div className="mt-[60px]">
        <Routes>
          <Route path="" element={<HomePage />} />
          <Route path="/about" element={<About />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/contact" element={<ContactForm />} />
          <Route path="/procural-well-being" element={<ProcuralWellBeing />} />
          <Route path="/employee-feedbackform" element={<EmpFeedbackForm />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </div>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="min-h-screen bg-white">
      <Router>
        <AppRoutes />
      </Router>

      {/* <ChatWidget /> */}
    </div>
  );
}

export default App;
